<div class="flex flex-col items-start">
  <div class="flex">
    <div class="section-description w-full max-w-72 pr-16">
      <div class="subtitle">{{ 'PROFILE.LANGUAGE.TITLE' | translate }}</div>
      <div class="mt-3 text-xs">
        {{ 'PROFILE.LANGUAGE.DESCRIPTION' | translate }}
      </div>
    </div>
    <div class="flex-grow pt-8">
      <mat-radio-group
        aria-label="Select an option"
        (change)="setLanguage($event.value)"
        [formControl]="languageFormControl"
        color="primary"
      >
        @for (option of translatedOptions; track option) {
          <mat-radio-button [value]="option.value">
            {{ option.label }}
          </mat-radio-button>
        }
      </mat-radio-group>
    </div>
  </div>
</div>
